import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs';
import { Subject } from 'rxjs';
import { ProjectsService } from '../../../../../../core/projects.service';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-change-orders-request-side-nav-wrapper',
    templateUrl: './change-orders-request-side-nav-wrapper.component.html',
    styleUrls: ['./change-orders-request-side-nav-wrapper.component.scss'],
    standalone: false
})
export class ChangeOrdersRequestSideNavWrapperComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tabGroup') tabs: MatTabGroup;
  @Input() data;
  createRequest = false;
  selectedTabIndex = 0;
  tabIndexMap = {
    details: 0,
    workflow: 1,
  };
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    public projectsService: ProjectsService,
    public route: ActivatedRoute,
    public router: Router,
  ) {

    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp.subTab) {
          this.selectedTabIndex = this.tabIndexMap[qp.subTab] || 0;
        }
      });
  }

  ngOnInit() {
    this.projectsService.createRequest
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.data = data.data;
        this.createRequest = data.type;
      });

    this.createRequest = !!this.data.createRequest;
  }

  ngAfterViewInit() {
    this.tabs._handleClick = this.onTabChange?.bind(this);
  }

  onTabChange(tab) {
    this.router.navigate([], {
      queryParams: {
        subTab: tab.textLabel.toLowerCase().replaceAll(' ', '-'),
      },
      queryParamsHandling: 'merge',
    });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
